// extracted by css-extract-rspack-plugin
export default {"cls1":"ProgressivePreviewList-cls1_mty","cls2":"ProgressivePreviewList-cls2_IgB ProgressivePreviewList-cls1_mty"};